package kz.dentalcrm.app.data.network.response_model.diagnosis

import kotlinx.serialization.Serializable

@Serializable
data class Links(
    val first: String? = null,
    val last: String? = null,
    val next: String? = null,
    val prev: String? = null,
    val self: String? = null
)